import Container from "../../UI/Container/Container";

const Error = (props) => {
    return(
        <div className="tsg-application-error">
            <Container>
                {props.errorMessage}
            </Container>
        </div>
    );
}

export default Error;